import api from '../services/api';
import { createBaseModule } from './base';

export default createBaseModule( {
  state: {
    report: [],
    quarters: [],
    report_total: 0,
      noMoreReport: false
  },
  mutations: {
    SET_DATA(state, {report, page}) {
      if (page > 1) {
        state.report = state.report.concat(report.data.items)
      }
      else
        state.report = report.data.items;
      if (state.report.length >= report.data.total)
        state.noMoreReport = true;
      state.quarters = report.data.quarters;
      state.loaded = true; // Устанавливаем флаг, что данные загружены
      state.report_total = report.data.total;
    },
  },
  actions: {
    async fetchReport({ commit, state }, {page, first=false, page_size=false, withoutpage= false}) {
      if (state.report.length > 0 && first) {
        return;
      }

      if (page == 1) {
        commit('RESET_STATE');
        state.noMoreReport = false;
      }

      let params = {
        page: page
      };
      if (page_size)
        params.page_size = page_size;

      if (withoutpage)
        params.withoutpage = withoutpage;

      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.get('api/finreport/', {
          params: params
        });
        if (response?.data?.data?.items) {
          commit('SET_DATA', {report: response.data, page: page});
          commit('SET_ERROR', null);
        }
        else {
          if (response?.data?.errors && Array.isArray(response.data.errors)) {
            // Проверяем есть ли в массиве ошибки с числовым кодом или code_error
            const hasTechnicalError = response.data.errors.some(
                error => typeof error.code === 'number' || error.code === 'code_error'
            );

            if (hasTechnicalError) {
              commit('SET_ERROR', 'Техническая ошибка');
            } else {
              const errorMessages = response.data.errors
                  .map(error => error.message)
                  .join('. ');

              commit('SET_ERROR', errorMessages);
            }
          } else {
            commit('SET_ERROR', 'Произошла ошибка при выполнении операции');
          }


        }

      } catch (error) {
        commit('SET_ERROR', error.message?error.message:'Ошибка при загрузке');
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
      report: state => state.report,
    quarters: state => state.quarters,
      reportLoading: state => state.loading,
      reportError: state => state.error,
      reportLoaded: state => state.loaded,
      report_total: state => state.report_total,
    noMoreReport: state => state.noMoreReport
  }
})